import { Add, Delete, Edit } from "@mui/icons-material";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import EmptyContent from "components/EmptyContent";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import React, {  useCallback, useEffect, useState } from "react";
import { QueryClient, useMutation } from "react-query";
import Search from "components/Search/Search";
import { handleError } from "helpers/utils";
import useFetchSection from "hooks/useFetchSection";
import DeleteModal from "components/UI/Form/partials/Delete";
import AddModal from "components/UI/Form/partials/Add";
import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import EditModal from "components/UI/Form/partials/Edit";
import { IClient, IClientInput } from "models/clients";
import { activityClient, addClient, ClientsCells, deleteClient, editClient, getClients } from "framework/clients";
import { getReseller } from "framework/reseller";
import { IReseller } from "models/reseller";
import AddModalClient from "./partials/Add";
import phone from 'phone';
import EditModalClient from "./partials/Edit";
import DoneIcon from '@mui/icons-material/Done';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import ActivityModal from "components/UI/Form/partials/Activity";
interface Props {
  feature: Feature;
}


function isValidNumber(countryCodeNumeric: string): boolean {
  const {isValid} = phone(countryCodeNumeric);
  return  isValid;
  
}

const ClientsList: React.FC<Props> = ({ feature }) => {
  const params = new URLSearchParams(window.location.search);
  const [loading2, setLoading2] = useState<boolean>(false);
  const [FilterClients, setFilterClients] = useState<IClient[]>([] as IClient[]);
  const [resellers, setResellers] = useState<IReseller[]>([] as IReseller[]);
  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openActivity, setOpenActivity] = useState<boolean>(false);
  const [activityFilter, setActivityFilter] = useState<string>(params.get('active')||'');
  const [resellerFilter, setResellerFilter] = useState<string>(params.get('resellerId')||'');
  const [selectedClient, setSelectedClient] = useState<IClient|null>(null);
  const [inputObj, setInputObj] = useState<IClientInput>({} as IClientInput);
  const { setAlert } = useAlert();

  // eslint-disable-next-line
  const queryClient = new QueryClient();

  const addClientMutation = useMutation({
    mutationFn: (createInput: IClientInput) => {
      return addClient(createInput);
    },
  });

  const editClientMutation = useMutation({
    mutationFn: (data: { createInput: IClientInput; planID: string }) => {
      return editClient(data.createInput, data.planID);
    },
  });

  const deleteClientMutation = useMutation({
    mutationFn: (id: string) => {
      return deleteClient(id);
    },
  });


  const activityClientMutation = useMutation({
    mutationFn: (id: number) => {
      return activityClient(id);
    },
  });


  const updateQueryParams = () => {
    const params = new URLSearchParams(window.location.search);

    resellerFilter ? params.set('resellerId', resellerFilter) : params.delete('resellerId');
    activityFilter ? params.set('active', activityFilter) : params.delete('active');

    window.history.replaceState(null, '', '?' + params.toString());
    revalidate()
  };

  const fetchResellers = useCallback(async () => {
    try {
      let response: any = await queryClient.fetchQuery("get resellers", () =>
        getReseller()
      );
      setResellers(response);
    
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);


  useEffect(() => {
    fetchResellers();
  }, []);
  
  useEffect(() => {
    updateQueryParams();
  }, [resellerFilter,activityFilter]);


  const buildQueryParams = () => {
    const params = new URLSearchParams();
    if (resellerFilter) params.append('resellerId', resellerFilter);
    if (activityFilter) params.append('active', activityFilter);
    return params.toString();
  };


  const {
    loading,
    data: Clients,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getClients(`?${buildQueryParams()}`),
    fetchPermission: async () => null,
    section: "Clients",
    onSuccess: (data) => setFilterClients(data),
  
  });

  if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  const handleChange = (name: string, value: any) => {
    if(name === 'ResellerId'){
      setInputObj((prev) => ({
        ...prev,
        [name]: value || 0,
      }));
      return
    }

    setInputObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenAdd = () =>{
    setOpenAdd(true);
    
      setInputObj((prev) => ({
        ...prev,
        CountryCode: '+961',
      }));
  } 

  const handleOpenEdit = (client: IClient) => {
    setSelectedClient(client);
    setInputObj((prev) => ({
      ...prev,
      ResellerId: client?.resellerId?.toString() || '',
      CountryCode: client.countryCode || '+961'
    }));
    setOpenEdit(true);
  };

  const handleOpenDelete = (client: IClient) => {
    setSelectedClient(client);
    setOpenDelete(true);
  };

  const handleOpenActivity = (client: IClient) => {
    setSelectedClient(client);
    setOpenActivity(true);
  };


  const handleClose = ()=>{
    setOpenAdd(false)
    setOpenEdit(false);
    setOpenDelete(false);
    setOpenActivity(false);
    setSelectedClient(null);
    setInputObj({} as IClientInput)
  }


  
  const handleActivityChange = (event: SelectChangeEvent<string>) => {
    setActivityFilter(event.target.value as string);
  };

  const handleResellerChange = (event: SelectChangeEvent<string>) => {
    setResellerFilter(event.target.value as string);
  };






  const getBodyCells = (row: IClient) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "clientName")
        return {
          id: "clientName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.clientName}</Typography>
            </TableCell>
          ),
        };
      if (key === "countryCode")
        return {
          id: "countryCode",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.countryCode}</Typography>
            </TableCell>
          ),
        };

      if (key === "phoneNumber")
        return {
          id: "phoneNumber",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.phoneNumber}</Typography>
            </TableCell>
          ),
        };

        if (key === "resellerName")
          return {
            id: "resellerName",
            element: (
              <TableCell align={"left"} key={i}>
                <Typography variant="body2">{row?.resellerName}</Typography>
              </TableCell>
            ),
          };

          if (key === "isActive")
            return {
              id: "isActive",
              element: (
                <TableCell align={"left"} key={i}>
                  <Typography variant="body2">{row?.isActive ? "Yes" : "No"}</Typography>
                </TableCell>
              ),
            };

      if (key === "clientId")
        return {
          id: "actions",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
              >
                
                  <Tooltip title={"Edit"}>
                    <IconButton
                      size={"small"}
                      color={"primary"}
                      onClick={() => handleOpenEdit(row)}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
              
          
                  <Tooltip title={"Delete"}>
                    <IconButton
                      size={"small"}
                      sx={{
                        color: "red",
                      }}
                      onClick={() => handleOpenDelete(row)}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>

<Button onClick={() => handleOpenActivity(row)} color={row.isActive?'inherit' :"success"} variant="contained">
{row.isActive ? 'Deactivate' : 'Activate'}  
</Button>
             
            
              </Stack>
            </TableCell>
          ),
        };
    });
    return cells;
  };

  const handleAdd = async () => {


    if (!inputObj.ResellerId && !(inputObj.PhoneNumber && inputObj.CountryCode))
      return setAlert({
        open: true,
        message: "The Phone number and country code are required",
        type: "error",
      });

      if ( !inputObj.ResellerId &&
        !isValidNumber(inputObj.CountryCode + inputObj.PhoneNumber ))
        return setAlert({
          open: true,
          message: "This Phone is not valid in this country",
          type: "error",
        });

        if(!inputObj.ResellerId) delete inputObj.ResellerId
    try {
      setLoading2(true);

      await addClientMutation.mutateAsync(inputObj);
      setAlert({
        open: true,
        message: "Client added successfully",
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IClientInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleEdit = async () => {

    if (!inputObj.ResellerId &&
      !isValidNumber((inputObj.CountryCode || selectedClient!?.countryCode) + (inputObj.PhoneNumber || selectedClient!?.phoneNumber) ))
      return setAlert({
        open: true,
        message: "This Phone is not valid in this country",
        type: "error",
      });

      if(inputObj.ResellerId === "") delete inputObj.ResellerId
    try {
      setLoading2(true);
      let createInput: IClientInput = {
        ClientName: inputObj.ClientName,
        CountryCode: inputObj.CountryCode,
        PhoneNumber: inputObj.PhoneNumber ,
        ResellerId: inputObj.ResellerId ,
      };
      await editClientMutation.mutateAsync({
        createInput,
        planID:selectedClient!?.clientId.toString()
      });
      setAlert({
        open: true,
        message: "Client updated successfully",
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IClientInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading2(true);
      await deleteClientMutation.mutateAsync(selectedClient!.clientId.toString());
      setAlert({
        open: true,
        message: "Client deleted successfully",
        type: "success",
      });
      revalidate();
      handleClose();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleActivity = async () => {
    try {
      setLoading2(true);
      await activityClientMutation.mutateAsync(selectedClient!.clientId);
      setAlert({
        open: true,
        message: "Activity Changes successfully",
        type: "success",
      });
      revalidate();
      handleClose();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error.response.data) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleSearch = async (value: string) => {
    if (!value) return setFilterClients(Clients!);
    let filtered = Clients!.filter((client) =>
      client?.clientName?.toLowerCase()?.includes(value?.toLowerCase()) || client?.countryCode?.toLowerCase()?.includes(value?.toLowerCase()) || client?.phoneNumber?.toLowerCase()?.includes(value?.toLowerCase())  || client?.resellerName?.toLowerCase()?.includes(value?.toLowerCase()) 
    );
    setFilterClients(filtered);
  };



  
  let resellerOptions = resellers.map((reseller) =>
    {
      return { value: reseller.resellerId.toString(), label: reseller.resellerName };
    });

  let addBasicFields: IFormField[] = [
    {
      name: 'ClientName',
      label: 'Client Name',
      type: InputTypes.TEXT,
      placeholder: 'Enter Client Name',
      internalLabel: true,
      required: true
    },
    {
      name: 'ResellerId',
      label: 'Reseller',
      placeholder: 'Select Reseller',
      canClear:true,
      type: InputTypes.SELECT,
      options:resellerOptions,
      internalLabel: true,
    }, 
  ];


  let editBasicFields: IFormField[] = [
    {
      name: 'ClientName',
      label: 'Client Name',
      type: InputTypes.TEXT,
      placeholder: 'Enter Client Name',
      defaultValue: selectedClient? selectedClient.clientName:'',
      internalLabel: true,
      required: true
    },
    {
      name: 'ResellerId',
      label: 'Reseller',
      placeholder: 'Select Reseller',
      type: InputTypes.SELECT,
      options:resellerOptions,
      canClear:true,
      defaultValue: resellerOptions.find(item => item.value === selectedClient!?.resellerId?.toString()) ,
      internalLabel: true,
    }, 
  ];


  return (
    <>
      <Stack spacing={2} p={2}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          sx={{ mb: 4 }}
        >
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Typography
              variant="h3"
              color={ "header.primary"}
            >
              {(feature.name)}
            </Typography>
          
              <Tooltip title={"Add"}>
                <IconButton
                  sx={{
                    color: "red",
                    height: 40,
                    width: 40,
                    transition: "0.5s",
                  }}
                  onClick={handleOpenAdd}
                >
                  <Add />
                </IconButton>
              </Tooltip>
      
          </Stack>
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Stack
              direction={{ lg: "row", xs: "column" }}
              spacing={1}
              width={"100%"}
            >
              <Search handleChange={handleSearch} placeholder={"Search"} />
           
            </Stack>
          </Stack>
        </Grid>

<div>
<FormControl variant="outlined" style={{ marginRight: '10px',minWidth:'200px' }}>
        <InputLabel>Status</InputLabel>
        <Select value={activityFilter} onChange={handleActivityChange} label="Activity">
        <MenuItem value="" style={{fontSize:'18px',fontStyle:'italic',fontWeight:'lighter'}}>None</MenuItem>
          <MenuItem value="true">Active</MenuItem>
          <MenuItem value="false">Inactive</MenuItem>
        </Select>
      </FormControl>

      <FormControl variant="outlined"  style={{ marginRight: '10px',minWidth:'200px' }}>
        <InputLabel>Reseller</InputLabel>
        <Select value={resellerFilter} onChange={handleResellerChange} label="Reseller">
        <MenuItem value="" style={{fontSize:'18px',fontStyle:'italic',fontWeight:'lighter'}}>None</MenuItem>
          {resellerOptions.map(reseller =>  <MenuItem value={reseller.value}>{reseller.label}</MenuItem>)}
        </Select>
      </FormControl>
</div>
        { FilterClients.length > 0 && (
          <List
            headCells={ClientsCells}
            data={FilterClients}
            getBodyCells={getBodyCells}
            feature={feature}
            canEdit={false}
          />
        )}
        {(!FilterClients || FilterClients.length === 0) &&
            <EmptyContent
              icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
              header={"No Clients"}
              message={"No Clients Exists Yet"}
            />
          }

      
      </Stack>

      {openAdd && (
        <AddModalClient
          open={openAdd}
          loading={loading2}
          disabled={!inputObj.ClientName}
          title="Add Client"
          inputObj={inputObj}
          basicFields={addBasicFields}
          onClose={handleClose}
          onSubmit={handleAdd}
          onChanges={handleChange}
        />
      )}
      {openEdit && (
        <EditModalClient
          open={openEdit}
          loading={loading2}
          title="Edit Client"
          inputObj={inputObj}
          client={selectedClient!}
          basicFields={editBasicFields}
          onClose={handleClose}
          onSubmit={handleEdit}
          onChanges={handleChange}
        />
      )}
      {openDelete && (
        <DeleteModal
          open={openDelete}
          loading={loading2}
          title="Delete Client"
          description="Are You Sure You Want to delete this client"
          onClose={handleClose}
          onSubmit={handleDelete}
        />
      )}

    {openActivity && (
        <ActivityModal
          open={openActivity}
          loading={loading2}
          title={`${selectedClient?.isActive ? 'Deactivate' : 'Activate' } Client`}
          description={`Are You Sure You Want to ${selectedClient?.isActive? 'Deactivate' : 'Activate'} this client`}
          onClose={handleClose}
          onSubmit={handleActivity}
        />
      )}
    </>
  );
};

export default ClientsList;
